






























































import { Guid } from 'guid-typescript'
import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../Mixins/ModelSetter'
import { errorNotificationWrapper, warningNotificationWrapper } from '../../../logic/helpers/NotificationService'
import BaseFileInput from '../../File/BaseFileInput/BaseFileInput.vue'
import { MessageNodeActionTypes, NodeTypes } from '../../Flow/logic/FlowEnums'
import { Scheme } from '../../Flow/logic/types/GeneralTypes'
import TextInput from '../../Pi/fields/TextInput/TextInput.vue'
import { AddNewFlowAction, FlowItem, FlowsListConfig } from '../types'

@Component({
  components: {
    BaseFileInput,
    TextInput
  },
  data() {
    return {
      AddNewFlowAction,
    }
  }
})
export default class CommonAddFlowActions extends Mixins<ModelSetter>(ModelSetter) {
  @VModel() currentAction!: AddNewFlowAction

  @Prop() createFlow!: FlowsListConfig['createFlow']

  @Prop() importFlow!: FlowsListConfig['importFlow']

  @Prop() copyFlow!: FlowsListConfig['copyFlow']

  @Prop() onFlowMastersButtonClick!: FlowsListConfig['onFlowMastersButtonClick']

  @Prop() activeFlow!: FlowItem

  @Emit()
  closeModal() {
    return null
  }

  newFlowTitle = ''

  importFlowFile: any = null

  isFlowCreating = false

  get inputTitle() {
    return [ AddNewFlowAction.Create, AddNewFlowAction.Copy ].includes(this.currentAction)
      ? 'flows_list_self_'
      : 'flows_list_import_file_'
  }

  get isAddNewFlowButtonDisabled() {
    const isTitleEmpty = !this.newFlowTitle.trim().length

    if (this.currentAction === AddNewFlowAction.Create) {
      return isTitleEmpty
    }
    if (this.currentAction === AddNewFlowAction.Import) {
      return isTitleEmpty || !this.importFlowFile
    }

    return false
  }

  newFlow: Scheme = {
    index: 5,
    items: [
      {
        data: {
          type: NodeTypes.Start,
        },
        x: 100000,
        y: 100500,
        output: 1,
        color: null,
      },
      {
        data: {
          inactive_action: {
            output: 2,
            time: 0,
          },
          type: NodeTypes.SendMessage,
          actions: [
            {
              type: MessageNodeActionTypes.Message,
              guid: Guid.create().toString(),
              variants: [
                {
                  text: this.$t('flow_new_message_text').toString(),
                  attachments: [],
                  disable_link_preview: false,
                  disable_notify: false,
                  pin: false,
                  remove_previous: false,
                  remove_after: 0,
                  send_after: 0,
                  protect_content: false,
                  buttons: [ [ {
                    guid: "aa03ab63-4db7-7693-bac5-9f4405bf6616",
                    type: "RunFlowNodeButton",
                    text: this.$t('new_send_message_flow_button_text').toString(),
                    output: 3
                  } ] ]
                }
              ]
            }
          ]
        },
        input: 4,
        output: 5,
        x: 100450,
        y: 100450,
        color: null,
      }
    ],
    connections: [
      {
        output: 1,
        input: 4,
        visible: true,
        color: null
      }
    ]
  }

  resetState() {
    this.resetNewFlowState()
    this.closeModal()
  }

  resetNewFlowState() {
    this.newFlowTitle = ''
    this.importFlowFile = null
  }

  addNewFlow() {
    if (this.newFlowTitle.trim()) {
      this.isFlowCreating = true

      const onCatch = (e:any) => {
        if (e) errorNotificationWrapper(this.$t('error').toString(), e)
      }

      if (this.currentAction === AddNewFlowAction.Create || this.currentAction === AddNewFlowAction.Copy) {
        if (this.currentAction === AddNewFlowAction.Copy) {
          this.copyFlow(this.activeFlow.key, this.newFlowTitle)
            .then(() => this.resetState())
            .catch(onCatch)
            .finally(() => this.isFlowCreating = false)
        }

        if (this.currentAction === AddNewFlowAction.Create) {
          this.createFlow(this.newFlowTitle, this.newFlow)
            .then(() => this.resetState())
            .catch(onCatch)
            .finally(() => this.isFlowCreating = false)
        }

      } else {
        this.importFlow(this.newFlowTitle, this.importFlowFile)
          .then(() => this.resetState())
          .catch(onCatch)
          .finally(() => this.isFlowCreating = false)
      }
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('flows_list_set_flow_name_alert').toString())
    }
  }

  mounted() {
    if (this.activeFlow && this.currentAction === AddNewFlowAction.Copy) {
      this.newFlowTitle = this.activeFlow.title + ' - copy'
    }
  }
}
